var windowWidth = window.innerWidth;

var asso = document.querySelector('.asso');

if (asso) {
    var containerWidth = document.querySelector('.asso__container').offsetWidth - 30;
    var containerSideWidth = (windowWidth - containerWidth) / 2;

    var image = document.querySelector('.anct__image');
    var imageWidth = containerSideWidth + 50

    image.style.width = imageWidth + 'px';
}